import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormTableListModal from '../editor/modals/FormTableListModal';
import { fetchReportLists } from 'modules/pvs_activities/redux/reportSlice';
import { Checkbox, FormControl, FormControlLabel, FormGroup } from '@mui/material';
import { FormLabel } from 'react-bootstrap';
import { useLazyGetFormDataVariablesQuery } from 'modules/pvs_activities/redux/service/formData';
import { processVariables } from 'modules/pvs_activities/helper.general';

const defaultProps = {
    label: 'Select',
    canAdd: false,
    disabled: false,
    listID: 0,
    templateId: 0,
    processVariables: false,
    missionId: 0,
    viewVertical: false,
};

const CheckboxesField = (rawProps) => {

    const props = { ...defaultProps, ...rawProps };

    const dispatch = useDispatch();
    const reportLists = useSelector(s => s.report.lists);

    const [values, setValues] = useState([]);
    const [triggerVariables, variablesRes] = useLazyGetFormDataVariablesQuery();

    const getListValues = () => {
        let listObj = reportLists?.find(r => r.id == props.listID);
        if (![undefined, null].includes(listObj)) {
            return listObj.relationElements;
        } else {
            return [];
        }
    }

    const handleChange = (value) => {
        const obj = { content: processVariablesLocal(value.value), list_id: props.listID, list_element_id: value.id }
        let checkIndex = values.findIndex(r => r.list_element_id === value.id);
        let valuesTemp = [...values];
        if (checkIndex == -1) {
            valuesTemp.push(obj);
        } else {
            valuesTemp.splice(checkIndex, 1);
        }
        setValues(valuesTemp);
        props.onChange(valuesTemp);
    }

    const processVariablesLocal = useCallback(
        (val) => {
            if (props.processVariables && variablesRes.isSuccess) return processVariables(variablesRes, val ?? "");
            return val;
        },
        [variablesRes, props.processVariables]
    );

    useEffect(() => {
        if (props.processVariables && ![undefined, null, "", 0, "0"].includes(props.missionId)) {
            triggerVariables(props.missionId, true);
        }
    }, [props.missionId, props.processVariables]);

    useEffect(() => {
        if (Array.isArray(props.value) && typeof props.value === 'object') {
            setValues(props.value);
        } else if (!Array.isArray(props.value) && typeof props.value === 'object') {
            setValues([props.value]);
        } else {
            setValues([]);
        }
    }, [props.value]);

    return (
        <FormControl component='fieldset'>
            <FormLabel component="legend" style={{ fontWeight: 'bold',  }}>
                {props.label ? props.label : props.defaultOptionLabel}
            </FormLabel>
            <FormGroup row={props.viewVertical === false}>
                {
                    getListValues().map(r => {
                        return (
                            <FormControlLabel
                                key={r.id}
                                control={<Checkbox />}
                                value={processVariablesLocal(r.value)}
                                label={processVariablesLocal(r.value)}
                                checked={values.map(s => s.list_element_id).includes(r.id)}
                                onChange={() => handleChange(r)}
                                disabled={props.disabled}
                                required={props.required}
                            />
                        );
                    })
                }
                {
                    [1, true].includes(props.canAdd) && (
                        <div className="col-md-2 col-sm-2 col-12">
                            <FormTableListModal
                                showDropdown={false}
                                listNameEditable={false}
                                templateID={props.templateId}
                                value={props.listID}
                                onListUpdate={() => dispatch(fetchReportLists({ mode: 'template', id: props.templateId }))}
                            />
                        </div>
                    )
                }
            </FormGroup>
        </FormControl>
    );
}

export default CheckboxesField;
